// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/dark","root":"dark-m__root__3sO1y"};